<template>
  <div class="en-city">
    <div
      class="show-content"
      @click="showListPanel"
      :class="{'no-data': !dataInfo.content,'is-disabled':disabled || fullData.disabled}"
    >
      {{ dataInfo && dataInfo.content ? dataInfo.content : "请选择" }}
    </div>
    <div class="show-list" v-if="showList">
      <div class="title">
        <i class="close-icon el-icon el-icon-close" @click="showList = false"></i>
        {{ fullData.name ? fullData.name : "地址选择" }}
      </div>
      <div class="container">
        <div class="left-list">
          <div
            class="left-item"
            :class="{'active': activeTab === 'province'}"
            @click="changeTab('province')"
          >
            {{ dataInfo && dataInfo.provinceName ? dataInfo.provinceName : "请选择" }}
          </div>
          <div
            class="left-item"
            v-if="dataInfo && dataInfo.provinceId && parseInt(fullData.addrRange,10) !== 4"
            :class="{'active': activeTab === 'city'}"
            @click="changeTab('city')"
          >
            {{ dataInfo && dataInfo.cityName ? dataInfo.cityName : "请选择"}}
          </div>
          <div
            class="left-item"
            v-if="
            dataInfo &&
            dataInfo.provinceId &&
            dataInfo.cityId &&
            parseInt(fullData.addrRange,10) !== 4 &&
            parseInt(fullData.addrRange,10) !== 3
          "
            :class="{'active': activeTab === 'district'}"
            @click="changeTab('district')"
          >
            {{ dataInfo && dataInfo.districtId ? dataInfo.districtName :"请选择" }}
          </div>
        </div>
        <div class="right-list">
          <div
            class="right-item"
            v-for="item in list"
            :key="item.id"
            @click="selectedInfo(item)"
          >
            {{ item.name }}
            <div
              class="right-item-selected"
              v-if="
               activeTab==='province' ? dataInfo && dataInfo.provinceId === item.id :
               activeTab === 'city' ? dataInfo && dataInfo.cityId === item.id :
               dataInfo.district && dataInfo && dataInfo.districtId === item.id"
            >
              <i class="el-icon el-icon-check"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="show-list address" v-if="showAddress">
      <div class="title">
        <i class="close-icon el-icon el-icon-close" @click="showAddress = false"></i>
        详细地址
        <i class="confirm-icon el-icon el-icon-check" @click="confirmFinished"></i>
      </div>
      <div class="container">
        <div class="container-item">
          <div class="label">
            详细地址：
          </div>
          <div class="components">
            <en-input v-model="dataInfo.address" placeholder="请输入详细地址"></en-input>
          </div>
        </div>
      </div>
    </div>
    <en-tips v-model="showTips" :tips="message"></en-tips>
  </div>
</template>

<script>
import enInput from "./../en-input";
import enTips from "./../en-tips";

export default {
  name: "index",
  components: {enInput, enTips},
  props: {
    value: {
      default: {}
    },
    fullData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showList: false,
      activeTab: "province",
      list: [],
      dataInfo: {},
      showAddress: false,
      message: "",
      showTips: false
    };
  },
  created() {
    if (this.fullData.mdValue) {
      this.dataInfo = this.fullData.mdValue ? this.fullData.mdValue : {}
    }
  },
  watch: {
    showList(nVal) {
      if (nVal) {
        this.activeTab = "province";
        this.dataInfo = this.fullData.value ? this.fullData.value : {}
        this.getProvinceList();
      }
    }
  },
  methods: {
    /**
     * @description 显示/隐藏城市选择器
     */
    showListPanel() {
      this.showList = !this.disabled && !this.fullData.disabled;
    },
    /**
     * @description 切换字典类型
     * @param type 字典类型
     */
    changeTab(type) {
      this.activeTab = type;
      if (type === "province") {
        this.dataInfo.cityId = null;
        this.dataInfo.cityName = null;
        this.dataInfo.districtId = null;
        this.dataInfo.districtName = null;
        this.getProvinceList();
      }
      if (type === "city") {
        this.dataInfo.districtId = null;
        this.dataInfo.districtName = null;
        this.getCityList();
      }
      if (type === "district") {
        this.getDistrict();
      }
    },
    /**
     * @description 获取省份列表
     */
    async getProvinceList() {
      let result = await this.$api.post("/mdSearchAddressInfo");
      if (result.isSuccess) {
        this.list = result.data;
      } else {
        this.showTips = true;
        this.message = result.msg;
      }
    },
    /**
     * @description 获取城市清单
     */
    async getCityList() {
      let result = await this.$api.post("/mdSearchAddressInfo", {
        params: {
          parentId: this.dataInfo.provinceId
        }
      });
      if (result.isSuccess) {
        this.list = result.data;
      } else {
        this.showTips = true;
        this.message = result.msg;
      }
    },
    /**
     * @description 获取区域列表
     */
    async getDistrict() {
      let result = await this.$api.post("/mdSearchAddressInfo", {
        params: {
          parentId: this.dataInfo.cityId
        }
      });
      if (result.isSuccess) {
        this.list = result.data;
      } else {
        this.showTips = true;
        this.message = result.msg;
      }
    },
    /**
     * @description 选择数据进行回调
     * @param itemData
     */
    selectedInfo(itemData) {
      if (this.activeTab === "province") {
        this.dataInfo.provinceId = itemData.id;
        this.dataInfo.provinceName = itemData.name;
        if (parseInt(this.fullData.addrRange, 10) === 4) {
          this.dataInfo.content = this.dataInfo.provinceName;
          this.$emit("input", this.dataInfo);
          this.$emit("change", this.fullData);
          this.showList = false;
        } else {
          this.dataInfo.cityId = null;
          this.dataInfo.cityName = null;
          this.dataInfo.districtId = null;
          this.dataInfo.districtName = null;
          this.activeTab = "city";
          this.getCityList();
        }
      } else if (this.activeTab === "city") {
        this.dataInfo.cityId = itemData.id;
        this.dataInfo.cityName = itemData.name;
        if (parseInt(this.fullData.addrRange, 10) === 3) {
          this.dataInfo.content = this.dataInfo.provinceName + this.dataInfo.cityName;
          this.$emit("input", this.dataInfo);
          this.$emit("change", this.fullData);
          this.showList = false;
        } else {
          this.dataInfo.districtId = null;
          this.dataInfo.districtName = null;
          this.activeTab = "district";
          this.getDistrict();
        }
      } else {
        this.dataInfo.districtId = itemData.id;
        this.dataInfo.districtName = itemData.name;
        if (parseInt(this.fullData.addrRange, 10) === 2) {
          this.dataInfo.content = this.dataInfo.provinceName + this.dataInfo.cityName +
            this.dataInfo.districtName;
          this.showList = false;
          this.$emit("input", this.dataInfo);
          this.$emit("change", this.fullData);
        } else {
          this.showAddress = true;
        }
      }
    },
    /**
     * @description 选择省市区信息后，检测地址信息是否已填写
     */
    confirmFinished() {
      // 如果地址信息未填写，提示继续填写
      if (!this.dataInfo.address || this.dataInfo.address.trim() === "") {
        this.showTips = true;
        this.message = "请填写详细地址";
        // 否则直接整理数据进行提交
      } else {
        this.dataInfo.content =
          this.dataInfo.provinceName +
          this.dataInfo.cityName +
          this.dataInfo.districtName +
          this.dataInfo.address;
        this.$emit("input", this.dataInfo);
        this.$emit("change", this.fullData);
        this.showList = false;
        this.showAddress = false;
      }
    }
  }
};
</script>

<style lang="scss">
  .en-city {
    background-color: #fcb8b8;
    position: relative;
    text-align: right;
    width: 100%;

    .show-list {
      position: fixed;
      z-index: 8;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      &.address {
        z-index: 9;
        background-color: #F7F7F7;

        .container {
          .container-item {
            background-color: #ffffff;
            width: 100%;
            height: 50px;
            line-height: 50px;
            display: flex;
            justify-content: flex-start;

            .label {
              width: 100px !important;
            }

            .components {
              width: calc(100% - 110px) !important;

              .en-input {
                width: 100%;
              }
            }
          }
        }
      }

      .title {
        text-align: center;
        color: #ffffff;
        position: relative;
        width: 100%;
        height: 50px;
        line-height: 50px;
        background-color: #31415A;

        .close-icon {
          position: absolute;
          font-size: 32px;
          top: 9px;
          left: 9px;
        }

        .confirm-icon {
          position: absolute;
          font-size: 32px;
          top: 9px;
          right: 9px;
        }
      }

      .container {
        display: flex;
        justify-content: flex-start;
        height: calc(100% - 50px);
        overflow: auto;

        .left-list {
          width: 32%;
          background-color: #E8E8E8;
          height: 100%;

          .left-item {
            text-align: left;
            padding-left: 20px;
            line-height: 50px;
            color: #848484;

            &.active {
              background-color: #ffffff;
              color: #333333;
            }
          }
        }

        .right-list {
          width: 68%;
          height: 100%;
          overflow: auto;
          padding-left: 3%;
          background-color: #ffffff;

          .right-item {
            border-bottom: 1px solid #E8E8E8;
            line-height: 50px;
            text-align: left;
            position: relative;

            &:nth-last-child(1) {
              border-bottom: none;
            }

            .right-item-selected {
              position: absolute;
              right: 20px;
              top: 0;
              color: #677EA3;
            }
          }
        }
      }
    }
  }
</style>
